export default {
  "Черный": "black",
  "Бежевый": "beige",
  "Серый": "gray",
  "Бардо": "#b00000",
  "Белый": "white",
  "Прозрачный": "transparent",
  "Синий": "blue",
  "Красный": "red",
  "Темно-салатовый": "#33ff33",
  "Фиолетовый": "violet",
  "Беж": "beige",
  "Оранжевый": "orange",
  "Металлик": "lightsteelblue",
  "Разноцветные": "linear-gradient(to right, red, green, blue)",
  "Коричневый": "brown",
  "Серебряный": "silver",
  "Черно-белый": "linear-gradient(to right, black 50%, white 50%)",
  "Розовый": "pink"
}
